
export const DZSWTL_FILTERS_CUSTOMTAX = 'customtax_';
export const DZSWTL_FILTERS_CUSTOMTAX_PRODUCT_ATTRIBUTE_ISOLATED_PREFIX = 'pa_';
export const DZSWTL_FILTERS_CUSTOMTAX_PRODUCT_ATTRIBUTE = 'customtax_pa_';
export const DZSWTL_VIEW_AJAX_MAIN_SHORTCODE_CONTAINER = 'dzswtl-main-ajax-target';
export const DZSWTL_VIEW_HTML_CLASS_MAIN_CONTAINER = 'dzs-woo-table';
export const DZSWTL_VIEW_AJAX_MAIN_ITEMS_CONTAINER = 'dzswtl-ajax-container';
export const DZSWTL_MODEL_SHOP_INITIALLY_SETUP = 'dzswtl_shop_initiallySetuped';
export const DZSWTL_FILTERS_SINGLETON = 'filters_singleton';
export const DZSWTL_TABLE_FILTERS_CURRENT_ARGUMENTS_KEY = 'dzswtl_curr_args';

/**
 * filter values set by the user
 * @type {string}
 */
export const DZSWTL_TABLE_FILTERS_USER_SET_FILTERS = 'dzswtl_user_set_args';